import { ConfigurationText } from '@tableau/metrics-engine';
import React from 'react';

import { DetailsTooltipStyles } from '~src/spacesPlatform/components/card/DetailsTooltipStyles';

import { Messages } from '../../../codegen/Localize';
import {
  metadataText
} from '../MetricsSpace/MetricsStyles';

export interface MetricConfigurationInfoProps {
  configurationText?: ConfigurationText;
}

const flexRow: React.CSSProperties = {
  display: 'flex',
  paddingTop: '5px'
};

const fixedFlexColumn: React.CSSProperties = {
  // Make sure to update the width of this column whenever the
  // text inside changes. The goal is to have about 16px of space
  // between the widest text in this column and the dynamic text column.
  flex: '0 0 105px',
};

const dynamicTextColumn: React.CSSProperties = {
  flex: 1,
};

const textNoHeader: React.CSSProperties = {
  paddingTop: '10px'
};

const renderEmptyConfigurationSection = () => {
  return (
    <div className={DetailsTooltipStyles.MetadataSection} data-tb-test-id={'metadata-configuration-header'} >
        <div className={DetailsTooltipStyles.MetadataTitle} tabIndex={-1}>{Messages.metricConfiguration()}</div>
        <div style={textNoHeader}>
          <div style={metadataText} data-tb-test-id={'no-configuration'}>
            {Messages.metricNoConfiguration()}
          </div>
        </div>
    </div>
  );
};

export function MetricConfigurationInfo(props: MetricConfigurationInfoProps) {
  if (!props.configurationText || (!props.configurationText.comparisonText && !props.configurationText.windowText)) {
    return renderEmptyConfigurationSection();
  }
  return (
    <div  className={DetailsTooltipStyles.MetadataSection} data-tb-test-id={'metadata-configuration-header'} >
        <div className={DetailsTooltipStyles.MetadataTitle} tabIndex={-1}>{Messages.metricConfiguration()}</div>
        { props.configurationText.windowText && <div style={flexRow}>
          <div style={fixedFlexColumn}>
            <div style={metadataText}>
              {Messages.metricDateRange()}
            </div>
          </div>
          <div style={dynamicTextColumn}>
            <div style={metadataText} data-tb-test-id={'metadata-date-range'}>
              {props.configurationText.windowText}
            </div>
          </div>
          </div>}
        {props.configurationText.comparisonText && <div style={flexRow}>
          <div style={fixedFlexColumn}>
            <div style={metadataText}>
              {Messages.metricComparison()}
            </div>
          </div>
          <div style={dynamicTextColumn}>
            <div style={metadataText} data-tb-test-id={'metadata-comparison'}>
              {props.configurationText.comparisonText}
            </div>
          </div>
        </div>}
      </div>
  );
}

